export default (function (a) {
  return Math.round(1e4 * (a + Number.EPSILON)) / 1e4;
});